import {createFileRoute, redirect} from '@tanstack/react-router'
import SessionDetails from "../../components/Sessions/SessionDetails.tsx";
import {useContext, useEffect} from "react";
import {RecordingsContext} from "../../context/RecordingsContext.tsx";
import {isAuthenticated} from "../../utils/auth.ts";
import Layout from "../../components/Layouts/Layout.tsx";

export const Route = createFileRoute('/sessions/$sessionId')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { sessionId } = Route.useParams();
  const { setActiveRecording } = useContext(RecordingsContext);
  
  useEffect(() => {
    setActiveRecording(Number(sessionId));
  }, [sessionId]);
  
  return (
    <Layout>
      <SessionDetails/>
    </Layout>
  );
}
